import { Buffer } from 'buffer'
import { createApp } from 'vue'
import App from './App.vue'
import './assets/process-sheet.css'
import { initInjectProbe } from './js/dapp/injectProbe.mjs'
import { initTronInjectProbe } from './js/dapp/tronInjectProbe.mjs'

const g = typeof window !== 'undefined' ? window : {}
if (!g.Buffer) {
  g.Buffer = Buffer
}

initInjectProbe()
initTronInjectProbe()

createApp(App).mount('#app')
